import CRLogoSVG from "components/svg/CRLogo";
import TEXT from "localisation";
import Link from "next/link";
import AreaContainer from "../AreaContainer";
import styles from './breadcrumbs.module.css';
import globalStyles from '../result.module.css';

interface Props {
    category: any,
    type: any,
    location: {
        uri: string,
        name: string
        parents: Parent[]
    }
}

interface Parent {
    name: string,
    uri: string
}

const Breadcrumbs = ({ category, type, location }: Props) => {
    let parent: Parent | null = null;
    if (location && location.parents && Array.isArray(location.parents) && location.parents.length > 0) {
        parent = location.parents[0];
    }

    const textLabel = `${type.toUpperCase()}_${type === "property" ? "ALL" : category.toUpperCase()}`;
    const labelUpperPlural = TEXT[`${textLabel}_LABEL_UPPER_PLURAL`];
    const textLableUri = TEXT[`${textLabel}_URI`];
    return <AreaContainer area="breadcrumbs" style={null} extraClass={undefined}>
        <div className={`${styles.BreadcrumbWrapper}`}>
            <Link href="/" passHref prefetch={false} legacyBehavior>
                <a title="Home">
                    <CRLogoSVG variant="icon" uid="breadcrumbs" />
                </a>
            </Link>
            <div className={styles.slash}>
                &gt;
            </div>
            <Link href={`/${textLableUri}`} passHref prefetch={false} legacyBehavior>
                <a title={`Search for ${labelUpperPlural}`}>
                    <p className={`${globalStyles.largeText} ${globalStyles.lightColorText}`}  >{TEXT[`${textLabel}_LABEL_UPPER_PLURAL`]}</p>
                </a>
            </Link>
            {parent && <>
                <div className={styles.slash}>
                    &gt;
                </div>
                <Link href={`/${textLableUri}/${parent.uri}`} passHref prefetch={false} legacyBehavior>
                    <a title={`${labelUpperPlural} in ${parent.name}`}><p className={`${globalStyles.largeText} ${globalStyles.lightColorText}`} >{parent.name}</p></a>
                </Link>
            </>}
            {location && <>
                <div className={styles.slash}>
                    &gt;
                </div>
                <Link href={`/${textLableUri}/${location.uri}`} passHref prefetch={false} legacyBehavior>
                    <a title={`${labelUpperPlural} in ${location.name}`}><p className={`${globalStyles.largeText} ${globalStyles.lightColorText}`} >{location.name}</p></a>
                </Link>
            </>}
            <div className={styles.slash}>
                &gt;
            </div>
            <p className={`${globalStyles.largeText} ${styles.BreadcrumbType}`}>{type}</p>
        </div>
    </AreaContainer>
};

export default Breadcrumbs;
